var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"no-data"},[_c('svg',{attrs:{"viewBox":"0 0 16 16"}},[_c('use',{attrs:{"xlink:href":require("@/assets/sprite.svg") + "#record"}})]),_c('p',[_vm._v(_vm._s(_vm.$t('common.noRecords')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }